"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getIsImageEditorSaveButtonDisabled;

function getIsImageEditorSaveButtonDisabled(_ref) {
  var cropperMode = _ref.cropperMode,
      unsavedImgWidth = _ref.unsavedImgWidth,
      cropperWidth = _ref.cropperWidth,
      cropperHeight = _ref.cropperHeight;
  return !cropperMode || cropperMode === 'resize' && !unsavedImgWidth || cropperMode === 'crop' && (cropperHeight <= 0 || cropperWidth <= 0);
}

module.exports = exports.default;